var React = require('react');

export const DefaultGDD = {
  t_base: '',
  t_max: '',
  t_min: '',
};

export const DefaultYield = {
  grain: '',
  leaf: '',
};

export const getCropTypePrefix = (
  crops,
  cropType,
  cropVariety,
  cropFeature = 'general',
) => {
  let crop_type = '';

  if (crops[cropType]) {
    if (cropVariety in crops[cropType]) {
      const varietyData = crops[cropType][cropVariety];
      // Try 'general' first, then the target feature, then any existing feature
      let cropData = varietyData['general'] || varietyData[cropFeature];
      if (!cropData) {
        // Find any existing feature to extract the prefix from
        const existingFeatures = Object.keys(varietyData);
        if (existingFeatures.length > 0) {
          cropData = varietyData[existingFeatures[0]];
        }
      }
      if (cropData && cropData['crop_type']) {
        const fullCropType = cropData['crop_type'];
        const endIndex = fullCropType.indexOf(cropVariety) + cropVariety.length;
        if (endIndex !== -1) {
          return fullCropType.substring(0, endIndex);
        }
      }
    }
  }

  return crop_type;
};
